import {
    PROFILE_SPECIALCASES_FETCH,
    PROFILE_SPECIALCASES_IS_FETCING,
    PROFILE_SPECIALCASE_EDIT,
} from 'constants/profileSpecialCases'

export default function profileSpecialCasesReducer(state = {
    list: []
}, action) {
    switch (action.type) {
        case PROFILE_SPECIALCASES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case PROFILE_SPECIALCASE_EDIT:
            return {
                ...state,
            }
        case PROFILE_SPECIALCASES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileSpecialCases.js